// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Asystent',
  },
  close: {
    amigo: 'Zamknij Amigo',
    assistant: 'Zamknij asystenta',
  },
  brand: 'Marka',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Czaty',
  new_chat: 'Nowy czat',
  back: 'Wróć do czatu',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Nowe odpowiedzi w innym czacie',
  news_elsewhere_few: 'Nowe odpowiedzi w {{count}} innych czatach',
  news_elsewhere_many: 'Nowe odpowiedzi w {{count}} innych czatach',
  news_elsewhere_other: 'Nowe odpowiedzi w {{count}} innych czatach',
};
